<template>
  <div
    class="max-w-screen-lg xl:max-w-screen-xl mx-auto mt-10 md:mt-14 lg:mt-16">
    <div class="px-4 sm:px-6 md:px-8 mb-14 sm:mb-20 xl:mb-8">
      <div
        class="font-montserrat text-xl sm:text-2xl md:text-3xl lg:text-3xl font-semibold text-red-700 mb-2"
      >
        Vega Data Feeds
      </div>
      <p
        class="max-w-4xl text-lg md:text-xl font-montserrat text-gray-400 sm:leading-8 space-y-6 mb-6"
      >
        Get open and valuable data<br />to enrich trading
        experiences on a fully decentralised network
      </p>
    </div>
    <div class="-mt-16 xl:-mt-8 max-w-screen-lg xl:max-w-screen-xl flex">
      <div class="px-4 sm:px-6 md:px-8 mb-8 sm:mb-8 xl:mb-8 mt-12">
        <router-link
          to="/trades"
          class="shadow-lg font-montserrat w-full sm:w-auto flex-none bg-gradient-to-r from-red-500 to-red-400 hover:from-red-600 hover:to-red-500 text-white font-semibold leading-6 py-3 px-6 border border-transparent rounded-lg focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-red-900 focus:outline-none inline-flex items-baseline"
        >
          See Trades
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="white"
            width="18px"
            height="18px"
            class="h-6 w-6 fill-current place-self-end ml-1"
          >
            <g><rect fill="none" height="24" width="24" /></g>
            <g>
              <g />
              <g>
                <path
                  d="M21.9,8.89l-1.05-4.37c-0.22-0.9-1-1.52-1.91-1.52H5.05C4.15,3,3.36,3.63,3.15,4.52L2.1,8.89 c-0.24,1.02-0.02,2.06,0.62,2.88C2.8,11.88,2.91,11.96,3,12.06V19c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-6.94 c0.09-0.09,0.2-0.18,0.28-0.28C21.92,10.96,22.15,9.91,21.9,8.89z M18.91,4.99l1.05,4.37c0.1,0.42,0.01,0.84-0.25,1.17 C19.57,10.71,19.27,11,18.77,11c-0.61,0-1.14-0.49-1.21-1.14L16.98,5L18.91,4.99z M13,5h1.96l0.54,4.52 c0.05,0.39-0.07,0.78-0.33,1.07C14.95,10.85,14.63,11,14.22,11C13.55,11,13,10.41,13,9.69V5z M8.49,9.52L9.04,5H11v4.69 C11,10.41,10.45,11,9.71,11c-0.34,0-0.65-0.15-0.89-0.41C8.57,10.3,8.45,9.91,8.49,9.52z M4.04,9.36L5.05,5h1.97L6.44,9.86 C6.36,10.51,5.84,11,5.23,11c-0.49,0-0.8-0.29-0.93-0.47C4.03,10.21,3.94,9.78,4.04,9.36z M5,19v-6.03C5.08,12.98,5.15,13,5.23,13 c0.87,0,1.66-0.36,2.24-0.95c0.6,0.6,1.4,0.95,2.31,0.95c0.87,0,1.65-0.36,2.23-0.93c0.59,0.57,1.39,0.93,2.29,0.93 c0.84,0,1.64-0.35,2.24-0.95c0.58,0.59,1.37,0.95,2.24,0.95c0.08,0,0.15-0.02,0.23-0.03V19H5z"
                />
              </g>
            </g>
          </svg>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LandingVega",
};
</script>
